import { apiActionTypes } from '../ActionTypes/apiActionTypes';
import type { ApiError } from '../Utils/httpClient';

export interface ApiErrorAction {
    type: typeof apiActionTypes.API_ERROR;
    error: ApiError;
}

export const apiActions = {
    apiErrorOccurred(error: ApiError): ApiErrorAction {
        return { type: apiActionTypes.API_ERROR, error };
    },
};

export default apiActions;
